import { render, staticRenderFns } from "./ListOfFeedbacks.vue?vue&type=template&id=6654ce1a&scoped=true&"
import script from "./ListOfFeedbacks.vue?vue&type=script&lang=js&"
export * from "./ListOfFeedbacks.vue?vue&type=script&lang=js&"
import style0 from "./ListOfFeedbacks.vue?vue&type=style&index=0&id=6654ce1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6654ce1a",
  null
  
)

export default component.exports